import { useContext, useEffect, useMemo, useRef, useState } from "react";
import CustomStyledTable from "../../../../components/table/CustomStyledTable";
import TableFilter from "../../../../components/table/filter/TableFilter";
import { useManageTableWithSearchParams } from "../../../../helpers/useManageTable";
import { EmployeeOvertimeEntryDto } from "../../../../models/employee-overtime-entry.dto";
import { EmployeeSupervisees } from "../../../../routes";
import useEditFormStore from "../../../../state-management/useEditFormStore";
import { useGetEmployeeWorkTime } from "../../../../services/employee-work-time.service";
// import { EmployeeWorkTimeColumns, SuperviseeWorkTimeColumns } from "../data";
import { REQUEST_QUERY_MODE } from "../../../../models/leave-request.dto";
import {
	employeeWorkTimeColumns,
	superviseeOvertimeColumns,
	superviseeWorkTimeColumns,
} from "../tanstack-columns";
import TanStackEmployeeTable from "../../../../components/table/TanStackEmployeeTable";
import { useTableConfiguration } from "../../../../helpers/useTableConfiguration";
import { TableId } from "../../../../models/table-configuration.dto";
import useUserStore from "../../../../state-management/useUserStore";

type SelfserviceWorkTimeViewProps = {
	superviseesMode: REQUEST_QUERY_MODE;
};
const SelfserviceWorkTimeView = ({
	superviseesMode,
}: SelfserviceWorkTimeViewProps) => {
	const supervisees = useContext(EmployeeSupervisees);
	const currentUser = useUserStore().currentUser.user;
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const { formDataValues, setFormData } = useEditFormStore();

	const {
		tableAPIRef,
		fetchedTableData,
		tableData,
		isLoading,
		pageCount,
		setTableData,
	} = useManageTableWithSearchParams<EmployeeOvertimeEntryDto>({
		fetchHook: useGetEmployeeWorkTime,
		options: {
			queryMode: superviseesMode,
		},
		reloadDeps: [superviseesMode],
	});

	const tableColumns = useMemo(() => {
		if (superviseesMode === "SELF") {
			return employeeWorkTimeColumns;
		}
		return superviseeOvertimeColumns;
	}, []);

	return (
		<>
			<div className="flex justify-between items-center mt-4 mb-4 lg:mb-8">
				<div className="flex items-center gap-3">
					{/* <APISearchInput 
						fallbackData={fetchedTableData}
						setTableData={setTableData}
						mutate={undefined as any}
					/> */}
					{superviseesMode === "SELF" ? (
						<TableFilter
							fields={[
								{
									title: "",
									fieldName: "",
									fieldType: "SORT",
									options: [
										{
											title: "Date Created",
											fieldName: "createdAt",
										},
										{
											title: "Date Modified",
											fieldName: "modifiedAt",
										},
									],
								},
								{
									title: "Time Unit",
									fieldName: "timeUnit",
									fieldType: "CHECKBOX_LIST",
									options: { HOUR: "HOUR", DAY: "DAY" },
								},
							]}
						/>
					) : (
						<TableFilter
							fields={[
								{
									title: "",
									fieldName: "",
									fieldType: "SORT",
									options: [
										{
											title: "Date Created",
											fieldName: "createdAt",
										},
										{
											title: "Date Modified",
											fieldName: "modifiedAt",
										},
									],
								},
								{
									title: "Supervisee",
									fieldName: "employeeId",
									fieldType: "SELECT_FIELD",
									options: supervisees || [],
									mapTexts: ["firstName", "lastName"],
								},
								{
									title: "Time Unit",
									fieldName: "timeUnit",
									fieldType: "CHECKBOX_LIST",
									options: { HOUR: "HOUR", DAY: "DAY" },
								},
							]}
						/>
					)}
				</div>
			</div>
			<div className="mobile-full-width max-lg:pl-4">
				<TanStackEmployeeTable
					tableId={TableId.WORK_TIME_SELF}
					data={tableData}
					columns={employeeWorkTimeColumns}
					loading={isLoading}
					onRowClick={(row, event) => {
						setFormData(row);
						setAnchorEl(event.currentTarget);
					}}
					onActionClick={(row, event) => {
						setFormData(row);
						setAnchorEl(event.currentTarget);
					}}
					initialColumnVisibility={{}}
					pageSize={10}
					pageCount={pageCount}
					apiRef={tableAPIRef}
				/>
				{/* <CustomStyledTable
					rows={tableData}
					columns={tableColumns}
					apiRef={tableAPIRef}
					loading={isLoading}
					pageCount={pageCount}
				/> */}
			</div>
		</>
	);
};

export default SelfserviceWorkTimeView;
